export default __webpack_public_path__ + "static/ares-7a91b4fae8398df9bae329d3867cddc9.jpg";